<template>
	<div class="warehouse-apply">
		<div class="form" v-if="ready">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
				<el-form-item label="云仓名称" prop="name" class="item">
					<el-input v-model="ruleForm.name" maxlength="64" show-word-limit placeholder="请输入云仓名称"></el-input>
				</el-form-item>
				<el-form-item label="云仓地址" prop="address" class="item">
					<el-input type="textarea" v-model="ruleForm.address" maxlength="255" show-word-limit :rows="3"
						placeholder="请输入云仓地址"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contact_name" class="item">
					<el-input v-model="ruleForm.contact_name" maxlength="50" show-word-limit placeholder="请输入联系人"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="contact_mobile" class="item">
					<el-input v-model="ruleForm.contact_mobile" maxlength="20" show-word-limit placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="保证金" prop="deposit_yuan" class="item">
					<el-input v-model="ruleForm.deposit_yuan" placeholder="请输入保证金金额">
						<template slot="append">元</template>
					</el-input>
					<p class="tip">最低 3000 元，当前账户余额 {{ balanceText }} 元</p>
				</el-form-item>
			</el-form>
		</div>
		<div class="btndiv" v-if="ready">
			<el-button type="primary" :loading="submitting" @click="onsub">提交申请</el-button>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'WarehouseApply',
		inject: ['appdata'],
		data() {
			var checkDeposit = (rule, value, callback) => {
				var num = parseFloat(value)
				if (value === '' || value === null || value === undefined) {
					callback(new Error('请输入保证金金额'))
					return
				}
				if (isNaN(num) || num <= 0) {
					callback(new Error('请输入有效金额'))
					return
				}
				if (num < 3000) {
					callback(new Error('保证金不能低于3000.00元'))
					return
				}
				callback()
			}
			return {
				ready: false,
				submitting: false,
				ruleForm: {
					name: '',
					address: '',
					contact_name: '',
					contact_mobile: '',
					deposit_yuan: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入云仓名称',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入云仓地址',
						trigger: 'blur'
					}],
					contact_name: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					contact_mobile: [{
						required: true,
						message: '请输入联系电话',
						trigger: 'blur'
					}],
					deposit_yuan: [{
						required: true,
						validator: checkDeposit,
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {
			balanceText() {
				var money = this.appdata && this.appdata.myinfo ? this.appdata.myinfo.money : ''
				return money === 0 || money ? money : '--'
			}
		},
		mounted() {
			this.checkApplication()
		},
		methods: {
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			checkApplication() {
				this.$axios.get('api/cloud_warehouse/my_application').then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						if (data.id && (data.state == 1 || data.state == 2)) {
							this.goIndex()
							return
						}
						if (data.id && (data.state == 3 || data.state == 4)) {
							this.ruleForm.name = data.name || ''
							this.ruleForm.address = data.address || ''
							this.ruleForm.contact_name = data.contact_name || ''
							this.ruleForm.contact_mobile = data.contact_mobile || ''
						}
						this.ready = true
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onsub() {
				this.$refs.ruleForm.validate((valid) => {
					if (!valid) {
						return
					}
					var fen = yuanToFen(this.ruleForm.deposit_yuan)
					this.submitting = true
					this.$axios.post('api/cloud_warehouse/apply', {
						name: this.ruleForm.name,
						address: this.ruleForm.address,
						contact_name: this.ruleForm.contact_name,
						contact_mobile: this.ruleForm.contact_mobile,
						deposit_amount: fen
					}).then(res => {
						this.submitting = false
						if (res.data.code === 0) {
							this.$message.success('已扣除保证金 ¥' + fenToYuan(fen) + '，等待平台审核')
							if (this.appdata && this.appdata.oninfo) {
								this.appdata.oninfo()
							}
							this.goIndex()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.submitting = false
						console.log(err)
					})
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-apply {
		padding: 20px 0;
	}

	.tip {
		margin-top: 6px;
		font-size: 12px;
		color: #909399;
		line-height: 1.4;
	}

	.btndiv {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	/deep/ .item .el-input,
	/deep/ .item .el-textarea {
		width: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/apply.vue